module.exports = __webpack_public_path__ + "img/matcap2.f4e8b695.jpg";